//$Id$
/**
 * @author Wesley Mascarenhas
 * @version $Id: app.global.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
export const GlobalVariable = Object.freeze({
  BASE_URL_API: '/Portal/api',
  APP_VERSION: '2.0.0'
});



// WEBPACK FOOTER //
// ./src/app/app.global.ts